import type { BadgeStatusVariant } from '@/shared/ui/Badge'

import type { PrizeUiStatus } from '../constants/status'

/** Participando usa paleta primary (`nova`), não laranja de `progress`. */
export const prizeBadgeVariant = (
  uiStatus: PrizeUiStatus
): BadgeStatusVariant => (uiStatus === 'progress' ? 'available' : uiStatus)
